// @flow
import SkeletonLoaderWrapper from "../../../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper";
import { issue_so_order } from "../../../../helpers/rights/rights";
import { withPermissionHOC } from "../../../permission/components/permissionHOC/permissionHOC";
import useCustomerSO from "../../hooks/useCustomerSO";
import Form from "./partials/form";

type Props = {
	issueId: string
};

const CustomerSO = (props: Props) => {
	const { issueId, onSubmitFailure, onSubmitSuccess, closeForm, onEmailSendSuccess } = props
	const { loading, data, items } = useCustomerSO({issueId})
	return (
		<SkeletonLoaderWrapper loading={loading}>
			{Object.keys(data).length > 0 && (
				<Form
					issueId={issueId}
					data={data}
					initialItems={items}
					onSubmitSuccess={onSubmitSuccess}
					onSubmitFailure={onSubmitFailure}
					onClose={closeForm}
					onEmailSendSuccess={onEmailSendSuccess}
				/>
			)}
		</SkeletonLoaderWrapper>
	);
};

export default withPermissionHOC(CustomerSO, [issue_so_order])